import { guideSteps } from "@/mocks/home";

export default function GuideSection() {
  return (
    <section id="guide" className="w-full bg-background-100">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-16 md:px-6 md:py-24">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-4">
            <span className="text-[11px] tracking-[0.32em] text-secondary-500">浏览指引</span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              三步找到想看的现场
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              本站只做静态展示，不接登录也不做提交。以下三个入口帮你在首页快速定位现场完整记录与直击过程。
            </p>
            <a
              href="#top"
              className="mt-8 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors duration-200 hover:bg-accent-600"
            >
              <i className="ri-arrow-up-line text-base" />
              回到首页入口条
            </a>
          </div>

          <div className="lg:col-span-8">
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 md:gap-6">
              {guideSteps.map((step, index) => (
                <div
                  key={step.title}
                  className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-6"
                >
                  <div className="flex items-center justify-between">
                    <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                      <i className={`${step.icon} text-xl`} />
                    </span>
                    <span className="font-heading text-2xl font-bold text-secondary-200">
                      0{index + 1}
                    </span>
                  </div>
                  <h3 className="mt-6 font-heading text-base font-semibold text-foreground-950">
                    {step.title}
                  </h3>
                  <p className="mt-3 text-xs leading-relaxed text-foreground-600 md:text-sm">
                    {step.desc}
                  </p>
                </div>
              ))}
            </div>

            <div className="mt-6 flex flex-col gap-4 rounded-lg border border-secondary-200 bg-secondary-50 p-6 sm:flex-row sm:items-center sm:justify-between">
              <div className="flex items-start gap-3">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-secondary-500 text-background-50">
                  <i className="ri-information-line text-lg" />
                </span>
                <div>
                  <h3 className="font-heading text-sm font-semibold text-secondary-950">
                    关于原档保留
                  </h3>
                  <p className="mt-1 text-xs leading-relaxed text-secondary-800 md:text-sm">
                    每段现场都标注了实拍、直击或录制类型，仅作浏览参考，请在确认内容类型后再决定是否保留。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}